import { render, staticRenderFns } from "./NotificacionesPage.vue?vue&type=template&id=152ce3be&scoped=true"
import script from "./NotificacionesPage.js?vue&type=script&lang=js&external"
export * from "./NotificacionesPage.js?vue&type=script&lang=js&external"
import style0 from "./NotificacionesPage.vue?vue&type=style&index=0&id=152ce3be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152ce3be",
  null
  
)

export default component.exports